import { render, staticRenderFns } from "./QRRegistrationChart.vue?vue&type=template&id=5c9473e4&scoped=true"
import script from "./QRRegistrationChart.vue?vue&type=script&lang=js"
export * from "./QRRegistrationChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9473e4",
  null
  
)

export default component.exports